import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterOnlyFeedbackWithContactInfo = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterOnlyFeedbackWithContactInfo'),
);
